import { useShow, useOne, useTranslate } from "@pankod/refine-core";
import { Show, Typography, Icons, BooleanField, DateField } from "@pankod/refine-antd";
import { IMunicipality, IProvince } from 'interfaces';

const { Title, Text } = Typography;

export const MunicipalityShow = () => {
  const translate = useTranslate();
  const { queryResult } = useShow<IMunicipality>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  const { data: provinceData } = useOne<IProvince>({
    resource: 'provinces',
    id: record?.province_id || '',
    queryOptions: {
      enabled: !!record?.province_id,
    },
  });

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>{translate('municipalities.fields.id')}</Title>
      <Text>{record?.id}</Text>

      <Title level={5}>{translate('municipalities.fields.denomination')}</Title>
      <Text>{record?.denomination}</Text>

      <Title level={5}>{translate('municipalities.fields.province.title')}</Title>
      <Text>{provinceData?.data.denomination}</Text>

      <Title level={5}>{translate('municipalities.fields.created_at')}</Title>
      <DateField format='lll' value={record?.created_at} />

      <Title level={5}>{translate('municipalities.fields.updated_at')}</Title>
      <DateField format='lll' value={record?.updated_at} />
    </Show>
  );
};
